let map;
const mapElement = document.getElementById('google_map');

async function initiateGoogleMap() {
  const cards = document.querySelectorAll('.store-locator-cards__filtered');
  const asideCards = document.querySelectorAll('.store-locator-cards__aside-filtered');

  const storeLongitude = Array.from(document.querySelectorAll('.store-locator__card-content-aside .store-locator-card__longitude'))
    .map(item => Number(item.textContent))
    .filter(n => !isNaN(n));

  const storeLatitude = Array.from(document.querySelectorAll('.store-locator__card-content-aside .store-locator-card__latitude'))
    .map(item => Number(item.textContent))
    .filter(n => !isNaN(n));

  const coordinateTitle = Array.from(document.querySelectorAll('.store-locator__card-content-aside .store-locator-card__coordinate-title'))
    .map(item => item.textContent);

  const coordinateAddress = Array.from(document.querySelectorAll('.store-locator__card-content-aside .store-locator-card__address'))
    .map(item => item.textContent);

  const mapZoomLevelElement = document.getElementById('map-zoom-level');
  let mapZoomLevel = mapZoomLevelElement ? Number(mapZoomLevelElement.innerHTML) : 4;
  const mapZoomLevelUnit = mapZoomLevel <= 18 ? 3 : 0;

  const locations = [];
  for (let i = 0; i < storeLongitude.length; i++) {
    const coordinateT = coordinateTitle[i] || '';
    const coordinateA = coordinateAddress[i] || '';
    const tooltipContent = coordinateA && !coordinateT ? coordinateA : coordinateT;

    locations.push([
      `<b>${tooltipContent}</b><br/><a href="https://maps.google.com/?q=${storeLatitude[i]},${storeLongitude[i]}" target="_blank" style="text-decoration: underline;">Location</a>`,
      storeLatitude[i],
      storeLongitude[i]
    ]);
  }

  // Centre par défaut sur Marseille
  let centerLatitude = 43.2965;
  let centerLongitude = 5.3698;

  // Si des magasins sont trouvés, recalculer le centre
  if (storeLatitude.length > 0 && storeLongitude.length > 0) {
    const minLongitude = Math.min(...storeLongitude);
    const minLatitude = Math.min(...storeLatitude);
    const maxLongitude = Math.max(...storeLongitude);
    const maxLatitude = Math.max(...storeLatitude);

    centerLatitude = (minLatitude + maxLatitude) / 2;
    centerLongitude = (minLongitude + maxLongitude) / 2;
  }

  if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
    return;
  }

  map = new google.maps.Map(mapElement, {
    zoom: mapZoomLevel,
    center: { lat: centerLatitude, lng: centerLongitude },
    scrollwheel: true,
    gestureHandling: 'greedy',
    disableDefaultUI: true,
    backgroundColor: '#89b4f8'
  });

  const bounds = new google.maps.LatLngBounds();
  const pinIcon = { url: mapElement.dataset.mapPinIcon };
  const infowindow = new google.maps.InfoWindow({ maxWidth: 200 });

  const setMapClickHandler = (item, i) => {
    item.addEventListener('click', function () {
      map.panTo(new google.maps.LatLng(locations[i][1], locations[i][2]));
      map.setZoom(mapZoomLevel + mapZoomLevelUnit);
    });
  };

  for (let i = 0; i < locations.length; i++) {
    setMapClickHandler(asideCards[i], i);
    setMapClickHandler(cards[i], i);

    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(locations[i][1], locations[i][2]),
      map,
      title: '',
      icon: pinIcon
    });

    bounds.extend(marker.position);

    google.maps.event.addListener(marker, 'click', (function (marker, count) {
      return function () {
        infowindow.setContent(locations[count][0]);
        infowindow.open(map, marker);
        map.panTo(this.getPosition());
      };
    })(marker, i));
  }

  // Ajuste la carte pour englober tous les magasins si disponibles
  if (locations.length > 0) {
    map.fitBounds(bounds);
  }
}

initiateGoogleMap();
